import './_style.scss';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

class BubbleProgress extends Component {

    static propTypes = {
        pageArray: PropTypes.arrayOf(PropTypes.string),
        currentElement: PropTypes.string
    };

    static defaultProps = {
        pageArray: [],
        currentElement: ""
    };

    buildBubbleElements = () => {

        const targetIndex = this.props.pageArray.indexOf(this.props.currentElement);

        return this.props.pageArray.map((element, index) => {

            let bulletDiv =
                <div className="bullet-completed">
                    <i className="fa fa-check" />
                </div>;
            if (index > targetIndex && targetIndex !== -1) bulletDiv = <div className="bullet-upcoming" />;
            if (index === targetIndex) bulletDiv = <div className="bullet-active" />;

            return (
                <div key={index} className="bubble-element">
                    {bulletDiv}
                    <div className="text-label">{element}</div>
                </div>
            );
        });
    }

    render() {
        return (
            <div className="bubble-progress">
                <div className="bubble-container">
                    <div className="bubble-line" />
                    {this.buildBubbleElements()}
                </div>
            </div>
        );
    }
}

export default BubbleProgress;
